import { Component, inject, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-seats',
  templateUrl: './modal-seats.component.html',
  styleUrls: ['./modal-seats.component.css']
})
export class ModalSeatsComponent implements OnInit {
  private readonly _modalRef: NzModalRef = inject(NzModalRef);
  limit: number;
  copyLimit: number;

  constructor() {}

  ngOnInit() {
    this.copyLimit = this.limit;
  }

  closeModal() {
    this._modalRef.close();
  }

  save() {
    this._modalRef.close(this.limit);
  }

  isChangeSeats(): boolean {
    return this.copyLimit == this.limit;
  }
}
